import React, { useState } from "react";
import { StepIndicator } from "./Messaging/StepIndicator/StepIndicator";
import IOSNotificationForm from "./Messaging/IOSNotificationForm/IOSNotificationForm";

import "./stylesNewPromotion.css";
import { AppleIcon, MailIcon, PlusIcon } from "./Icons";
import IOSNotificationPreview from "./Messaging/IOSNotificationForm/IOSNotificationPreview/IOSNotificationPreview";
import EmailNotificationForm from "./Messaging/EmailNotificationForm/EmailNotificationForm";
import EmailNotificationPreview from "./Messaging/EmailNotificationForm/EmailNotificationPreview/EmailNotificationPreview";
import PromoNotificationForm from "./Messaging/PromoNotificationForm/PromoNotificationForm";
import PromoNotificationPreview from "./Messaging/PromoNotificationForm/PromoNotificationPreview/PromoNotificationPreview";
import TargetAudiences from "./TargetAudiences/TargetAudiences";
import ScheduleDelivery from "./ScheduleDelivery/ScheduleDelivery";
import Summary from "./Summary/Summary";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";

const CHANNEL = {
  email: "email",
  ios: "ios",
  promo: "promo",
};

const getStepLabel = (id) => {
  switch (id) {
    case 1:
      return AppStrings.MESSAGING;
    case 2:
      return AppStrings.TARGET_AUDIENCES;
    case 3:
      return AppStrings.PAM_NEW_PROMOTION_SCHEDULE_DELIVERY;
    case 4:
      return AppStrings.SUMMARY;
    default:
      return "";
  }
};

function NewPromotion() {
  usePageTitle(AppStrings.PROMOTIONS_MANAGEMENT);

  const [activeNavItem, setActiveNavItem] = React.useState(CHANNEL.email);
  const [stepIndicators, setStepIndicators] = useState([
    { id: 1, isActive: true },
    { id: 2, isActive: false },
    { id: 3, isActive: false },
    { id: 4, isActive: false },
  ]);

  const activeStep = stepIndicators.find((step) => step.isActive).id;

  const [notificationData, setNotificationData] = useState({
    title: "Pay 1- Get X2. Get +100% on your Rebet Cash Bundle!",
    description: "Unlock Savings on Rebet Cash Purchase!",
    dateTime: "Apr 20, 2025 at 9:12 PM",
    timeLeft: "2d 1h left",
  });

  const [activePromoVariant, setActivePromoVariant] = useState("purchase_match");

  return (
    <>
      <div className="promotions-management-container">
        <div className="new-promotion promotions-management">
          <main className="wizardContainer">
            <header className="wizardHeader">
              {stepIndicators.map((step) => (
                <StepIndicator
                  key={step.id}
                  number={step.id}
                  label={getStepLabel(step.id)}
                  isActive={step.isActive}
                  setStepIndicators={setStepIndicators}
                />
              ))}
            </header>
            {activeStep === 1 && (
              <>
                <nav className="channelBar">
                  <button
                    className={`channelButton ${
                      activeNavItem === CHANNEL.email
                        ? "channelButtonActive"
                        : ""
                    }`}
                    onClick={() => setActiveNavItem(CHANNEL.email)}
                  >
                    <MailIcon />
                    <span>{AppStrings.EMAIL}</span>
                  </button>
                  <button
                    className={`channelButton ${
                      activeNavItem === CHANNEL.ios
                        ? "channelButtonActive"
                        : ""
                    }`}
                    onClick={() => setActiveNavItem(CHANNEL.ios)}
                  >
                    <AppleIcon />
                    <span>{AppStrings.IOS_PUSH}</span>
                  </button>
                  <button
                    className={`channelButton ${
                      activeNavItem === CHANNEL.promo
                        ? "channelButtonActive"
                        : ""
                    }`}
                    onClick={() => setActiveNavItem(CHANNEL.promo)}
                  >
                    {AppStrings.PROMO}
                  </button>
                  <div className="appleIconWrapper"></div>
                  <button className="addChannelButton">
                    <PlusIcon />
                  </button>
                </nav>

                {activeNavItem === CHANNEL.email && <EmailNotificationForm />}

                {activeNavItem === CHANNEL.ios && (
                  <IOSNotificationForm
                    setNotificationData={setNotificationData}
                  />
                )}

                {activeNavItem === CHANNEL.promo && (
                  <PromoNotificationForm
                    setActivePromoVariant={setActivePromoVariant}
                  />
                )}
              </>
            )}
            {activeStep === 2 && <TargetAudiences />}
            {activeStep === 3 && <ScheduleDelivery />}
            {activeStep === 4 && <Summary />}
          </main>
          {activeStep === 1 && (
            <div className="communication-preview">
              {activeNavItem === CHANNEL.email && <EmailNotificationPreview />}
              {activeNavItem === CHANNEL.ios && (
                <IOSNotificationPreview notificationData={notificationData} />
              )}

              {activeNavItem === CHANNEL.promo && (
                <PromoNotificationPreview
                  activePromoVariant={activePromoVariant}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default NewPromotion;
